module.exports = __webpack_public_path__ + "img/p__妇幼.6de9bf53.png";